import { cookieConsentId } from './shared/constants';
import { createScript } from './shared/helpers';

let loadPromise: Promise<void> | null = null;
let pollingInterval: number | null = null;

/**
 * On-demand loader:
 * call when you need to ensure CookieConsent is ready.
 */
export default async function ensureCookieConsentReady(languageCode: string) {
    // Already available
    if ((window as any).CookieConsent) return Promise.resolve();

    // Return cached promise if already loading
    if (loadPromise) return loadPromise;

    loadPromise = new Promise((resolve, reject) => {
        const existingScript = document.getElementById(cookieConsentId);

        const startPolling = () => {
            if (pollingInterval !== null) return; // prevent multiple intervals
            pollingInterval = window.setInterval(() => {
                if ((window as any).CookieConsent) {
                    if (pollingInterval !== null) {
                        clearInterval(pollingInterval);
                        pollingInterval = null;
                    }
                    resolve();
                }
            }, 50);
        };

        if (existingScript) {
            startPolling();
            return;
        }

        const script = createScript(languageCode);

        script.onload = () => {
            // Listen for consent event
            window.addEventListener('CookieInformationConsentGiven', () => resolve(), {
                once: true
            });

            // Fallback: poll until global is set
            startPolling();
        };

        script.onerror = () => {
            loadPromise = null; // allow retry next time
            reject(new Error('CookieConsent failed to load'));
        };

        document.body.appendChild(script);
    });

    return loadPromise;
}
